import './MainPage.scss'

import HeroComponent from '../../components/HeroComponent/HeroComponent'
import ProjectsComponent from '../../components/ProjectsComponent/ProjectsComponent';
import ContactPage from '../ContactPage/ContactPage';
import AboutMeComponent from '../../components/AboutMeComponent/AboutMeComponent';

function MainPage() {

  return (
    <section className='main' id='main'> 
      <HeroComponent />
      <AboutMeComponent />
      <ProjectsComponent />
      <ContactPage />
    </section>
  )
}

export default MainPage